import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { VerticalSliderComponent } from './vertical-slider.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    exports: [VerticalSliderComponent],
    declarations: [VerticalSliderComponent],
    providers: [],
})
export class VerticalSliderModule { }
